// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./index.css";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useState } from "react";

export default function CenterPage() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const uid = localStorage.getItem("uid");

  return (
    <div className="min-h-screen bg-neutral-900 text-neutral-100">
      {/* 标题区域 */}
      <div className="px-4 py-6 border-b border-neutral-800">
        <h1 className="text-xl font-medium text-center">
          {translate(getText("在線客服"))}
        </h1>
      </div>

      {/* 内容区域 */}
      <div className="p-4">
        <div className="max-w-md mx-auto">
          <div 
            className="bg-neutral-800 
                       rounded-lg p-4 shadow-card cursor-pointer
                       transform transition-all duration-300 hover:scale-105
                       active:scale-95"
            onClick={() => {
              if (uid) {
                navigate("/chat");
              } else {
                navigate("/murmurchat");
              }
            }}
          >
            <div className="flex items-center justify-between">
              <span className="text-lg font-medium">
                {translate(getText("在線客服"))}
              </span>
              <svg 
                className="w-5 h-5 text-neutral-400" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 5l7 7-7 7" 
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
